import { Card, CardActionArea, CardContent, Typography, Chip, Box } from '@mui/material';
import { MenuBook as JournalIcon } from '@mui/icons-material';
import type { Journal } from '../../types/api.types';

interface Props {
  journal: Journal;
  onClick: () => void;
}

export const JournalCard = ({ journal, onClick }: Props) => (
  <Card sx={{ height: '100%' }}>
    <CardActionArea onClick={onClick} sx={{ height: '100%', p: 1 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <JournalIcon sx={{ mr: 1, color: 'primary.main' }} />
          <Typography variant="h6" noWrap>{journal.name}</Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip label={journal.learningLanguage} size="small" color="primary" variant="outlined" />
          <Chip label={journal.nativeLanguage} size="small" variant="outlined" />
        </Box>
      </CardContent>
    </CardActionArea>
  </Card>
);
